import React from 'react';
import PropTypes from 'prop-types';
import { Button, TableCell, TableRow } from '@mui/material';

/** A full-width row at the top or bottom of a grid that adds the period beyond it. */
export default function AdjacentPeriodRow ({ label, icon, disabled, onClick, colSpan = 9 }) {
    return (
        <TableRow>
            <TableCell colSpan={colSpan} sx={{ py: 0.25 }}>
                <Button size="small" startIcon={icon} disabled={disabled} onClick={onClick} sx={{ textTransform: 'none' }}>
                    {label}
                </Button>
            </TableCell>
        </TableRow>
    );
}

AdjacentPeriodRow.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.node,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    colSpan: PropTypes.number,
};
